import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneFileService } from '../../../../../projects/kiene-core/src/lib/services/files/kiene-file.service';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import {
    DateTableColumn,
    NumberTableColumn,
    TableColumn,
    TextTableColumn,
} from '../../../components/kiene-table/table-column';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { Material } from '../material';

@Component({
    selector: 'kiene-artikel-lager-historie-dialog',
    templateUrl: './artikel-lager-historie-dialog.component.html',
    styleUrls: ['./artikel-lager-historie-dialog.component.scss'],
})
export class ArtikelLagerHistorieDialogComponent implements OnInit {
    lagerTableDescriptor: TableDescriptor = new TableDescriptor();
    abgabebelegTableDescriptor: TableDescriptor = new TableDescriptor();
    headline = '';

    private artikelParams: HttpParams;

    constructor(
        public dialogRef: MatDialogRef<ArtikelLagerHistorieDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private artikel: Material,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private localStorageService: LocalStorageService,
        private fileService: KieneFileService,
    ) {}

    ngOnInit(): void {
        this.artikelParams = new HttpParams().set('artikel_id', this.artikel.artikel_id.toString());
        this.headline = `Historie – ${this.artikel.bezeichnung}`;

        this.initLagerTable(this.artikelParams);
        this.initAbgabebelegTable(this.artikelParams);
    }

    downloadLagerExcel(): void {
        this.downloadExcel(
            'artikel_lager_historie/read.php',
            'erstellt desc',
            this.lagerTableDescriptor.columns,
        );
    }

    downloadAbgabebelegExcel(): void {
        this.downloadExcel(
            'artikel_abgabebeleg_historie/read.php',
            'datum desc,aa_id desc',
            this.abgabebelegTableDescriptor.columns,
        );
    }

    private downloadExcel(apiPath: string, orderBy: string, columns: TableColumn[]): void {
        const params = this.artikelParams.set('orderby', orderBy).set('search', '');
        this.fileService.downloadExcel(this.apiBaseUrl + apiPath, params, {
            columnsCommaSeparated: this.buildDownloadColumns(columns),
        });
    }

    private buildDownloadColumns(columns: TableColumn[]): string {
        return columns
            .filter(col => col.isActive)
            .map(col => `${col.name}::${col.title}`)
            .join(';');
    }

    private initLagerTable(params: HttpParams): void {
        this.lagerTableDescriptor.headline = 'Lagerbestand';
        this.lagerTableDescriptor.uniqueIdentifier = 'Artikel-Lagerhistorie';
        this.lagerTableDescriptor.apiUrl = this.apiBaseUrl + 'artikel_lager_historie/';
        this.lagerTableDescriptor.params = params;
        this.lagerTableDescriptor.initialSortColumn = 'erstellt';
        this.lagerTableDescriptor.initialSortDirection = 'desc';
        this.lagerTableDescriptor.showDetails = false;
        this.lagerTableDescriptor.searchPlaceholder = 'Lagerhistorie durchsuchen';
        this.lagerTableDescriptor.showDownloads = true;
        this.lagerTableDescriptor.permissionDownload = 1001;

        this.lagerTableDescriptor.columns = [
            new TextTableColumn('typ', 'Typ'),
            new TableColumn('erstellt', 'Datum', 'datetime'),
            new TableColumn('menge', 'Menge', 'number'),
            new TextTableColumn('charge', 'Charge'),
            new DateTableColumn('mhd', 'MHD'),
            new TextTableColumn('lagerplatz_quelle', 'Von'),
            new TextTableColumn('lagerplatz_ziel', 'Nach'),
            new TextTableColumn('referenz', 'Bezug'),
            new TextTableColumn('lieferant', 'Lieferant'),
        ];

        if (this.localStorageService.currentUserIsAdmin()) {
            this.lagerTableDescriptor.columns.push(new NumberTableColumn('einzelpreis', 'Einzelpreis', '1.2-2', '€'));
        }

        this.lagerTableDescriptor.permissionView = 1001;
    }

    private initAbgabebelegTable(params: HttpParams): void {
        this.abgabebelegTableDescriptor.headline = 'Abgabebelege';
        this.abgabebelegTableDescriptor.uniqueIdentifier = 'Artikel-Abgabebeleg-Historie';
        this.abgabebelegTableDescriptor.apiUrl = this.apiBaseUrl + 'artikel_abgabebeleg_historie/';
        this.abgabebelegTableDescriptor.params = params;
        this.abgabebelegTableDescriptor.initialSortColumn = 'datum';
        this.abgabebelegTableDescriptor.initialSortDirection = 'desc';
        this.abgabebelegTableDescriptor.showDetails = false;
        this.abgabebelegTableDescriptor.searchPlaceholder = 'Abgabebelege durchsuchen';
        this.abgabebelegTableDescriptor.showDownloads = true;
        this.abgabebelegTableDescriptor.permissionDownload = 1001;

        this.abgabebelegTableDescriptor.columns = [
            new TextTableColumn('abgabebeleg_nr', 'Abgabebeleg'),
            new DateTableColumn('datum', 'Datum'),
            new TableColumn('artikelmenge', 'Menge', 'number'),
            new TextTableColumn('kunde', 'Kunde'),
            new TextTableColumn('tierarzt', 'Tierarzt'),
            new TextTableColumn('gruppe', 'Gruppe'),
            new TextTableColumn('chargen', 'Chargen'),
            new TextTableColumn('identifikation', 'Identifikation'),
            new TextTableColumn('status', 'Status'),
        ];

        this.abgabebelegTableDescriptor.permissionView = 1001;
    }
}
